import { z } from 'zod';
import { nullableList } from '../zod-helpers';

const uuid = z.string().uuid();

export const storyCollectionStateSchema = z.enum(['draft', 'published', 'archived']);
export type StoryCollectionState = z.infer<typeof storyCollectionStateSchema>;

export const storyCollectionSchema = z.object({
  id: uuid,
  slug: z.string(),
  title_en: z.string().nullable().optional(),
  title_ar: z.string().nullable().optional(),
  title_eg_ar: z.string().nullable().optional(),
  desc_en: z.string().nullable().optional(),
  desc_ar: z.string().nullable().optional(),
  desc_eg_ar: z.string().nullable().optional(),
  cover_media_id: uuid.nullable().optional(),
  state: storyCollectionStateSchema,
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});
export type StoryCollection = z.infer<typeof storyCollectionSchema>;
export const storyCollectionListSchema = nullableList(storyCollectionSchema);

export const storyCollectionUpsertSchema = z.object({
  slug: z
    .string()
    .min(3)
    .max(120)
    .regex(/^[a-z0-9][a-z0-9-]*$/u, 'lowercase letters, digits, and hyphens only'),
  title_en: z.string().min(1).max(200),
  title_ar: z.string().max(200).optional(),
  title_eg_ar: z.string().max(200).optional(),
  desc_en: z.string().max(2000).optional(),
  desc_ar: z.string().max(2000).optional(),
  desc_eg_ar: z.string().max(2000).optional(),
  cover_media_id: uuid.optional(),
  state: storyCollectionStateSchema.optional(),
});
export type StoryCollectionUpsert = z.infer<typeof storyCollectionUpsertSchema>;

export const storyCollectionCreateResponseSchema = z.object({ id: uuid });

export const storyCollectionItemSchema = z
  .object({
    story_id: uuid.optional(),
    position: z.number().int().optional(),
    title: z.string().nullable().optional(),
    cover: z.string().nullable().optional(),
  })
  .passthrough();
export type StoryCollectionItem = z.infer<typeof storyCollectionItemSchema>;

export const storyCollectionItemAddRequestSchema = z.object({
  story_id: uuid,
  position: z.number().int().min(0).optional(),
});
export type StoryCollectionItemAddRequest = z.infer<typeof storyCollectionItemAddRequestSchema>;

export const storyCollectionItemAddResponseSchema = z.object({ position: z.number().int() });

export const storyNarrationLocaleSchema = z.enum(['en', 'ar']);
export type StoryNarrationLocale = z.infer<typeof storyNarrationLocaleSchema>;

export const storyNarrationRequestSchema = z.object({
  narration_media_id: uuid,
  narrator_id: uuid,
  narration_locale: storyNarrationLocaleSchema,
});
export type StoryNarrationRequest = z.infer<typeof storyNarrationRequestSchema>;
